export default "__VITE_PUBLIC_ASSET__656e4427__"